import React from 'react';

const GenericZoomOverlay: React.FC = () => {
  return <div>I'm an overlay </div>;
};

export default GenericZoomOverlay;
